import { Routes } from '@angular/router';
// Third party packages
// Custom packages - Misc
import { RoleGuard } from 'src/app/shared/guards/role.guard';
// Custom packages - Component
import { PersonalDataListComponent } from 'src/app/modules/personal-data/pages/personal-data-list/personal-data-list.page';
var ɵ0 = {
    permissions: ['canReadPropertiesList']
};
var routes = [
    {
        path: 'list',
        component: PersonalDataListComponent,
        canActivate: [RoleGuard],
        data: ɵ0,
    },
    {
        path: '**',
        redirectTo: 'it/errors/404'
    }
];
var PersonalDataRoutingModule = /** @class */ (function () {
    function PersonalDataRoutingModule() {
    }
    return PersonalDataRoutingModule;
}());
export { PersonalDataRoutingModule };
export { ɵ0 };
